import React from "react";
import Banner from "../Banner";

const AdvisoryBoard = () => {
  return <Banner name={"AdvisoryBoard"} Title={"Advisory Board"} />;
};

export default AdvisoryBoard;
